import { useMutation } from '@apollo/client'
import { AddClearanceSetup, AddClearanceSetupVariables } from '../../types'
import { ADD_CLEARANCE_SETUP } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useAddClearanceSetup = ({ onCompleted }: Props) =>
  useMutation<AddClearanceSetup, AddClearanceSetupVariables>(ADD_CLEARANCE_SETUP, { onCompleted })
